
// import React from 'react';
// import { useTheme } from 'styled-components';
// import { useNavigate } from 'react-router-dom';
// import {
//   Nav, NavLink, NavbarContainer, Span, NavLogo, NavItems,
//   GitHubButton, LinkedIn, ButtonContainer, MobileIcon, MobileMenu,
//   MobileLink, NavItemWithDropdown, DropdownMenu, DropdownItem
// } from './NavbarStyledComponent';

// import { FaBars } from 'react-icons/fa';
// import { Bio } from '../../data/constants';
// import logo from '../../images/HeroImage.jpg';
// import github from '../../images/github.png';
// import LinkedInIcon from '../../images/linkedin.png';

// const Navbar = () => {
//   const [isOpen, setIsOpen] = React.useState(false);
//   const theme = useTheme();
//   const navigate = useNavigate();

//   const handleScroll = (id) => {
//     navigate(`/#${id}`);
//     setIsOpen(false); // close mobile menu
//   };

//   return (
//     <Nav>
//       <NavbarContainer>
//         <NavLogo to='/'>
//           <a style={{ display: "flex", alignItems: "center", cursor: 'pointer' }} onClick={() => navigate('/')}>
//             <img
//               src={logo}
//               alt="Logo"
//               style={{
//                 borderRadius: '50%',
//                 border: `3px solid ${theme.primary}`,
//                 width: '50px',
//                 height: '50px',
//                 marginRight: '10px',
//               }}
//             />
//             <Span style={{ color: "white" }}>Dipanjan's</Span>
//           </a>
//         </NavLogo>

//         <MobileIcon>
//           <FaBars onClick={() => setIsOpen(!isOpen)} />
//         </MobileIcon>

//         <NavItems>
//           <NavLink as="div" onClick={() => handleScroll('about')}>About</NavLink>
//           <NavLink as="div" onClick={() => handleScroll('skills')}>Overview</NavLink>
//           <NavLink as="div" onClick={() => handleScroll('experience')}>Experience</NavLink>
//           <NavLink as="div" onClick={() => handleScroll('projects')}>Projects</NavLink>
//           <NavLink as="div" onClick={() => handleScroll('education')}>Education</NavLink>
//           <NavLink as="div" onClick={() => handleScroll('courses')}>Courses</NavLink>

//           <NavItemWithDropdown>
//             <NavLink>More</NavLink>
//             <DropdownMenu>
//               <li>
//                 <DropdownItem to="/Blog">Blog</DropdownItem>
//               </li>
//             </DropdownMenu>
//           </NavItemWithDropdown>
//         </NavItems>

//         <ButtonContainer>
//           <GitHubButton href={Bio.github} target="_blank">
//             <img src={github} alt="GitHub" style={{ width: '20px', marginRight: '8px' }} />
//             Github
//           </GitHubButton>
//           <LinkedIn href={Bio.linkedin} target="_blank">
//             <img src={LinkedInIcon} alt="GitHub" style={{ width: '23px', marginRight: '8px' }} />
//             Linked In
//           </LinkedIn>
//         </ButtonContainer>

//         {isOpen && (
//           <MobileMenu isOpen={isOpen}>
//             <MobileLink as="div" onClick={() => handleScroll('about')}>About</MobileLink>
//             <MobileLink as="div" onClick={() => handleScroll('skills')}>Overview</MobileLink>
//             <MobileLink as="div" onClick={() => handleScroll('experience')}>Experience</MobileLink>
//             <MobileLink as="div" onClick={() => handleScroll('projects')}>Projects</MobileLink>
//             <MobileLink as="div" onClick={() => handleScroll('education')}>Education</MobileLink>
//             <MobileLink as="div" onClick={() => handleScroll('courses')}>Courses</MobileLink>
//             <GitHubButton
//               style={{ padding: '10px 16px', background: `${theme.primary}`, color: 'white', width: 'max-content' }}
//               href={Bio.github}
//               target="_blank"
//             >
//               <img src={github} alt="GitHub" style={{ width: '20px', marginRight: '8px' }} />
//               Github
//             </GitHubButton>
//             <LinkedIn
//               href={Bio.linkedin}
//               style={{ padding: '10px 16px', background: `${theme.primary}`, color: 'white', width: 'max-content' }}
//               target="_blank"
//             >
//               <img src={LinkedInIcon} alt="GitHub" style={{ width: '23px', marginRight: '8px' }} />
//               Linked In
//             </LinkedIn>
//           </MobileMenu>
//         )}
//       </NavbarContainer>
//     </Nav>
//   );
// };

// export default Navbar;



import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import {
  Nav, NavLink, NavbarContainer, Span, NavLogo, NavItems,
  GitHubButton, LinkedIn, ButtonContainer, MobileIcon, MobileMenu,
  MobileLink, NavItemWithDropdown, DropdownMenu, DropdownItem
} from './NavbarStyledComponent';

import { FaBars } from 'react-icons/fa';
import { Bio } from '../../data/constants';
import logo from '../../images/HeroImage.jpg';
import github from '../../images/github.png';
import LinkedInIcon from '../../images/linkedin.png';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // Added state for dropdown in mobile
  const theme = useTheme();
  const navigate = useNavigate();

  const handleScroll = (id) => {
    navigate(`/#${id}`);
    setIsOpen(false); // close mobile menu
  };

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to='/'>
          <a style={{ display: "flex", alignItems: "center", cursor: 'pointer' }} onClick={() => navigate('/')}>
            <img
              src={logo}
              alt="Logo"
              style={{
                borderRadius: '50%',
                border: `3px solid ${theme.primary}`,
                width: '50px',
                height: '50px',
                marginRight: '10px',
              }}
            />
            <Span style={{ color: "white" }}>Dipanjan's</Span>
          </a>
        </NavLogo>

        <MobileIcon>
          <FaBars onClick={() => setIsOpen(!isOpen)} />
        </MobileIcon>

        <NavItems>
          <NavLink as="div" onClick={() => handleScroll('about')}>About</NavLink>
          <NavLink as="div" onClick={() => handleScroll('skills')}>Overview</NavLink>
          <NavLink as="div" onClick={() => handleScroll('experience')}>Experience</NavLink>
          <NavLink as="div" onClick={() => handleScroll('projects')}>Projects</NavLink>
          <NavLink as="div" onClick={() => handleScroll('education')}>Education</NavLink>
          <NavLink as="div" onClick={() => handleScroll('courses')}>Courses</NavLink>

          {/* Desktop Dropdown */}
          <NavItemWithDropdown>
            <NavLink onClick={() => setIsDropdownOpen(!isDropdownOpen)}>More</NavLink>
            {isDropdownOpen && (
              <DropdownMenu>
                <li>
                  <DropdownItem to="/Blog">Blog</DropdownItem>
                </li>
              </DropdownMenu>
            )}
          </NavItemWithDropdown>
        </NavItems>

        <ButtonContainer>
          <GitHubButton href={Bio.github} target="_blank">
            <img src={github} alt="GitHub" style={{ width: '20px', marginRight: '8px' }} />
            Github
          </GitHubButton>
          <LinkedIn href={Bio.linkedin} target="_blank">
            <img src={LinkedInIcon} alt="GitHub" style={{ width: '23px', marginRight: '8px' }} />
            Linked In
          </LinkedIn>
        </ButtonContainer>

        {isOpen && (
          <MobileMenu isOpen={isOpen}>
            <MobileLink as="div" onClick={() => handleScroll('about')}>About</MobileLink>
            <MobileLink as="div" onClick={() => handleScroll('skills')}>Overview</MobileLink>
            <MobileLink as="div" onClick={() => handleScroll('experience')}>Experience</MobileLink>
            <MobileLink as="div" onClick={() => handleScroll('projects')}>Projects</MobileLink>
            <MobileLink as="div" onClick={() => handleScroll('education')}>Education</MobileLink>
            <MobileLink as="div" onClick={() => handleScroll('courses')}>Courses</MobileLink>

          {/* Direct Blog link for mobile */}
          <MobileLink as="div" onClick={() => navigate('/Blog')}>Blog</MobileLink>

            <GitHubButton
              style={{ padding: '10px 16px', background: `${theme.primary}`, color: 'white', width: 'max-content' }}
              href={Bio.github}
              target="_blank"
            >
              <img src={github} alt="GitHub" style={{ width: '20px', marginRight: '8px' }} />
              Github
            </GitHubButton>
            <LinkedIn
              href={Bio.linkedin}
              style={{ padding: '10px 16px', background: `${theme.primary}`, color: 'white', width: 'max-content' }}
              target="_blank"
            >
              <img src={LinkedInIcon} alt="GitHub" style={{ width: '23px', marginRight: '8px' }} />
              Linked In
            </LinkedIn>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
